const GITHUB_URL = process.env.REACT_APP_GITHUB_URL;
const GITHUB_TOKEN = process.env.REACT_APP_GITHUB_TOKEN;

// To Get User Repos
export const getUserRepos = async () => {
    const params = new URLSearchParams({
        sort: 'created',
        per_page: 6,
    })
    const response = await fetch(`${GITHUB_URL}/users/molla-mainuddin/repos?${params}`);
    const data = await response.json();
    // console.log(data)
    return data;
}